import { biaIpType, biaIpTypeFullName } from "../types/index.const";

const biaIpTypeOptions = biaIpType.map((el, index) => ({
  value: el,
  label: biaIpTypeFullName[index],
}));
export default biaIpTypeOptions;
